
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/2026",
      function () {
        return require("private-next-pages/dashboard/2026.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/2026"])
      });
    }
  